module.exports = __webpack_public_path__ + "static/media/maritime-banner.7e9e7dc1.png";